import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
    _vm._b(
      {
        tag: "component",
        attrs: { "data-qa": "doctor-documents-modal" },
        scopedSlots: _vm._u(
          [
            !_setup.isMobile
              ? {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                _setup.isOpened = false
                              },
                            },
                          },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      staticClass:
                        "primary--text branding-btn branding-btn--background",
                      attrs: { color: "bg-primary", depressed: "", block: "" },
                      on: { click: _setup.onConfirm },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_setup.confirmLabel) + "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _setup.isOpened,
          callback: function ($$v) {
            _setup.isOpened = $$v
          },
          expression: "isOpened",
        },
      },
      "component",
      _setup.isMobile
        ? {}
        : {
            title: _setup.title,
            divider: true,
            size: "md",
          },
      false
    ),
    [
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            "div",
            { staticClass: "d-flex align-center mb-2" },
            [
              !_setup.documents.fakeDocuments
                ? _c(VIcon, { attrs: { color: "success", size: "24" } }, [
                    _vm._v("\n      ui-icon-shield-checkmark-40\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-h6",
                  class: _setup.documents.fakeDocuments
                    ? "text--text"
                    : "text-success--text ml-4",
                },
                [_vm._v("\n      " + _vm._s(_setup.title) + "\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-body-1 text-secondary--text mb-2" },
        [
          _setup.documents.fakeDocuments
            ? [_vm._v("\n      " + _vm._s(_setup.fakeDocumentsLead) + "\n    ")]
            : [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _setup.t(
                        "Специалист предоставил документы, а мы проверили их достоверность",
                        _setup.l10nOptions
                      )
                    ) +
                    "\n    "
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _setup.documents.fakeDocuments
        ? _vm._l(
            _setup.documents.fakeDocuments,
            function (fakeDocument, index) {
              return _c(
                "div",
                { key: index, staticClass: "d-flex py-3" },
                [
                  _c(VIcon, { attrs: { color: "text-error", size: "24" } }, [
                    _vm._v("\n        ui-icon-circle-warning\n      "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-body-1 ml-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.t(fakeDocument, _setup.l10nOptions) ||
                            fakeDocument
                        ) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              )
            }
          )
        : [
            _setup.documents.isEducationConfirmed
              ? _c(
                  "div",
                  { staticClass: "d-flex py-3" },
                  [
                    _c(
                      VIcon,
                      { attrs: { color: "text-success", size: "24" } },
                      [_vm._v("\n        ui-icon-check-circle\n      ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-body-1 ml-4" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Диплом о базовом образовании",
                              _setup.l10nOptions
                            )
                          ) +
                          "\n      "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.documents.isCategoryConfirmed
              ? _c(
                  "div",
                  { staticClass: "d-flex py-2" },
                  [
                    _setup.documents.isCategoryValid &&
                    !_setup.documents.isCategoryExpiringSoon
                      ? _c(
                          VIcon,
                          { attrs: { color: "text-success", size: "24" } },
                          [_vm._v("\n        ui-icon-check-circle\n      ")]
                        )
                      : _c(
                          VIcon,
                          { attrs: { color: "text-error", size: "24" } },
                          [_vm._v("\n        ui-icon-circle-warning\n      ")]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-4" }, [
                      _c("div", { staticClass: "text-body-1" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _setup.t(
                                "Удостоверение о категории",
                                _setup.l10nOptions
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      !_setup.documents.isCategoryValid
                        ? _c(
                            "div",
                            { staticClass: "text-body-2 text-error--text" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _setup.t(
                                      "Документ уже недействителен",
                                      _setup.l10nOptions
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _setup.documents.categoryExpiresDate
                        ? _c(
                            "div",
                            {
                              staticClass: "text-body-2",
                              class: _setup.documents.isCategoryExpiringSoon
                                ? "text-error--text"
                                : "text-secondary--text",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _setup.t(
                                      "Действительно до",
                                      _setup.l10nOptions
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_setup.categoryExpiresDateFormatted) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.documents.isScienceConfirmed
              ? _c(
                  "div",
                  { staticClass: "d-flex py-3" },
                  [
                    _c(
                      VIcon,
                      { attrs: { color: "text-success", size: "24" } },
                      [_vm._v("\n        ui-icon-check-circle\n      ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-body-1 ml-4" }, [
                      _vm._v(
                        "\n        " + _vm._s(_setup.scienceLabel) + "\n      "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }